export const flattenValues = (value: string | string[][]): string[] =>
  Array.isArray(value) ? value.flat() : []
